/**
 * ----------------------------------------------------------------------------
 * Initial Nonconformity State
 * ----------------------------------------------------------------------------
 * Summary:
 * Defines the default state for nonconformity records and pagination details.
 *
 * @author Chandan Singh
 * @created August-2026
 * ----------------------------------------------------------------------------
 */
import { INonConformanceListVM } from '../../models/response/INonconformityResponse'
const initialNonconformityState: INonConformanceListVM = {
    NonConformanceResponseList: [],
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
};

export default initialNonconformityState